import { apiUtils } from '../utils/api';

// Fetch all cameras
export const getCameraList = async () => {
  try {
    const data = await apiUtils.get('cameras/'); // <- returns response.data already
    // Handle both paginated and non-paginated responses
    if (Array.isArray(data)) return data;
    if (Array.isArray(data.results)) return data.results;
    return [];
  } catch (error) {
    console.error('[getCameraList ERROR]', error.message);
    throw new Error('Failed to fetch camera list');
  }
};

// Fetch a single camera by ID
export const getCamera = async (id) => {
  try {
    return await apiUtils.get(`cameras/${id}/`);
  } catch (error) {
    console.error('[getCamera ERROR]', error.message);
    throw new Error('Failed to fetch camera');
  }
};

// Create a new camera
export const createCamera = async (form) => {
  try {
    const payload = {
      camera_id: form.id,
      location: form.location,
    };
    return await apiUtils.post('cameras/', payload);
  } catch (error) {
    console.error('[createCamera ERROR]', error.message);
    throw new Error('Failed to create camera');
  }
};

// Update an existing camera
export const updateCamera = async (id, data) => {
  try {
    const payload = {
      camera_id: data.id,
      location: data.location,
    };
    return await apiUtils.put(`cameras/${id}/`, payload);
  } catch (error) {
    console.error('[updateCamera ERROR]', error.message);
    throw new Error('Failed to update camera');
  }
};

// Delete a camera by ID
export const deleteCamera = async (id) => {
  try {
    return await apiUtils.delete(`cameras/${id}/`);
  } catch (error) {
    console.error('[deleteCamera ERROR]', error.message);
    throw new Error('Failed to delete camera');
  }
};

export const getCameras = getCameraList;

export const sendCameraHeartbeat = async (cameraId, { keepaliveSeconds = 30, source = 'frontend' } = {}) => {
  try {
    return await apiUtils.post('camera-motion/heartbeat/', {
      camera: cameraId,
      keepalive_seconds: keepaliveSeconds,
      source,
    });
  } catch (error) {
    console.error('[sendCameraHeartbeat ERROR]', error?.message);
    throw new Error('Failed to contact camera heartbeat endpoint');
  }
};

